var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',[_vm._v(_vm._s(_vm.$t('404.title')))]),_c('p',[_vm._v(_vm._s(_vm.$t('404.body')))]),_c('a',{attrs:{"href":"/"}},[_c('h2',[_vm._v(_vm._s(_vm.$t('404.body')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }